import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const PortalHome = () => {
  return (
    <div className="py-4">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="text-center shadow-sm border-0">
            <Card.Body className="p-5">
              <h2 className="mb-4">Bienvenido a tu Portal de Transportes Emilia</h2>
              <p className="lead text-muted mb-5">
                Gestiona tus traslados de forma rápida y segura.
              </p>
              
              <div className="d-grid gap-3">
                <Link to="/portal/new-trip" className="btn btn-primary btn-lg">
                  ✨ Solicitar Nuevo Viaje
                </Link>
                <Link to="/portal/my-trips" className="btn btn-outline-secondary">
                  📅 Ver Mis Viajes
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PortalHome;
